import { render, staticRenderFns } from "./newPresentationGaz.vue?vue&type=template&id=5533e16c&scoped=true"
import script from "./newPresentationGaz.vue?vue&type=script&lang=js"
export * from "./newPresentationGaz.vue?vue&type=script&lang=js"
import style0 from "./newPresentationGaz.vue?vue&type=style&index=0&id=5533e16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5533e16c",
  null
  
)

export default component.exports